import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/app';
import 'firebase/auth';
import { useHistory } from "react-router-dom";
import {useStores} from "../../stores/context";
import * as firebaseui from 'firebaseui';
import { MatxLoading } from "matx";
import {observer} from "mobx-react";
import {setTitle} from "../utilities/setTitle";
require('arrive/minified/arrive.min.js');

declare global {
  interface Document {
    arrive?: any;
    unbindArrive?: any;
  }
}

const appleProvider = new firebase.auth.OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

const SignIn = observer(() => {

  const history = useHistory();

  const redirectUrl = (history.location.state as any)?.redirectUrl;

  const {authStore, userStore} = useStores();

  const [uiCallback, setUiCallback] = useState<firebaseui.auth.AuthUI | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [startedSignInProcess, setStartedSignInProcess] = useState(false);

  useEffect(() => {
    setTitle(`Sign In`);
  }, []);

  const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // We will display Google and Facebook as auth providers.
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      appleProvider.providerId
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.NONE, //disable accountchooser ui
    tosUrl: 'http://www.google.com',
    privacyPolicyUrl: 'http://www.google.com',
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: (credential: firebase.auth.UserCredential, nextUrl: string) => {

        const redirectUrlToUse = (redirectUrl ? redirectUrl :
            sessionStorage.getItem("redirectUrl")) || "/";

        authStore.onSignIn = () => {
          uiCallback?.reset();
          history.push(redirectUrlToUse);
        };
        if (credential.user?.uid === userStore.user?.uid) { //if the logged in user hasn't changed
          uiCallback?.reset();
          history.push(redirectUrlToUse);
        }
        return false;
      }
    }
  };

  useEffect(() => {
    if (redirectUrl) {
      sessionStorage.setItem("redirectUrl", redirectUrl);
    }

    const waitForElement = '[data-provider-id="google.com"] span.firebaseui-idp-text-long';

    document.arrive(".firebaseui-container", { onceOnly: true }, () => {
      setIsLoading(false);
    });

    document.arrive(".firebaseui-page-provider-sign-in", {  }, () => {
      setStartedSignInProcess(false);
    });

    document.arrive(".firebaseui-id-page-sign-in", {  }, () => {
      setStartedSignInProcess(true);
      const signInHeader = document.querySelector('h1.firebaseui-title');
      if (signInHeader) {
        signInHeader.innerHTML = `Sign in / up with email`;
      }
    });

    document.arrive(waitForElement, {  }, () => {
      const googleButton = document.querySelector('[data-provider-id="google.com"] span.firebaseui-idp-text-long');
      if (googleButton) {
        googleButton.innerHTML = `Sign in / up with Google`;
      }

      const appleButton = document.querySelector('[data-provider-id="apple.com"] span.firebaseui-idp-text-long');
      if (appleButton) {
        appleButton.innerHTML = `Sign in / up with Apple`;
      }

      const emailButton = document.querySelector('[data-provider-id="password"] span.firebaseui-idp-text-long');
      if (emailButton) {
        emailButton.innerHTML = `Sign in / up with email`;
      }

    });

    return () => {
      document.unbindArrive();
    }

  }, [setIsLoading, redirectUrl]);
  return (
    <div className="signup flex justify-center items-center w-full h-screen">
      <div className="p-8">
        <Card className="signup-card relative">
          <Grid container>
            <Grid item lg={5} md={5} sm={5} xs={12}>
              <div className="p-8 flex justify-center items-center h-full">
                <div className="text-center">
                  <a href="https://www.speedywaiver.io"><img src="/assets/images/logo-and-text.png" style={{height: "32px", width: "197px", minWidth: "197px", marginLeft: "27px"}} className="inline mb-8" alt="Logo"/></a>
                  <a href="https://www.speedywaiver.io"><img src="/assets/images/illustrations/dreamer.svg" alt="" className="px-4" /></a>

                </div>
              </div>
            </Grid>
            <Grid item lg={7} md={7} sm={7} xs={12}>
              <div className="p-8 h-full bg-light-gray relative" style={{minHeight: 200}}>
                {(isLoading || userStore.isSigningIn) && <MatxLoading text={userStore.isCreatingAccount ? "Creating account ..." : undefined}/>}
                {!startedSignInProcess && <div>speedyWaiver makes creating and signing electronic waivers fast and seamless. Sign in or create an account for a free trial. <a className="underline" href="https://www.speedywaiver.io">Learn more</a></div>}
                <StyledFirebaseAuth uiCallback={ui => {ui.disableAutoSignIn(); setUiCallback(ui); }} uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
              </div>
            </Grid>
          </Grid>
        </Card>
      </div>
    </div>
  );
});

export default SignIn;